var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('base-material-card',{attrs:{"icon":"mdi-newspaper"}},[_c('crud',{attrs:{"crudSettings":_vm.crudSettings,"headers":_vm.headers,"responseData":{data:_vm.items},"detailData":_vm.detailData,"forceUpdateTable":_vm.forceUpdate},on:{"onTableChange":_vm.updateTable}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }